<template>
  <div class="relative" :class="colSpan">
    <div class="relative flex items-center">
      <!-- SELECT -->
      <Field
        :id="handle || formField.handle"
        v-slot="{ field }"
        :name="handle || formField.handle"
        :label="label || formField.label || formField.display"
        :disabled="disabled"
        :rules="rulesAsString"
      >
        <FormSelectInput
          v-model="selectedValue"
          :handle="formField.handle"
          :options="computedOptions"
          v-bind="field"
          :placeholder="label || formField.label || formField.display"
          class="-m-px hyphens-auto border"
          :class="[
            error
              ? `
                border-notification-red
                focus-within:border-transparent
              `
              : 'border-transparent',
          ]"
        />
      </Field>
    </div>

    <!-- ERROR -->
    <TransitionExpand
      class="transition-all duration-300 ease-in-out"
      :open="!!error"
    >
      <p v-if="error" class="hyphens-auto pt-1 text-sm text-red-500">
        {{ error }}
      </p>
    </TransitionExpand>
  </div>
</template>

<!-- eslint-disable-next-line vue/block-lang -->
<script setup>
import { Field } from 'vee-validate'

const props = defineProps({
  handle: {
    type: String, default: null,
  },
  formField: {
    type: Object, default: null,
  },
  value: {
    type: null, default: '',
  },
  placeholder: {
    type: String, default: '',
  },
  rules: {
    type: [Array, String], default: '',
  },
  error: {
    type: String, default: null,
  },
  disabled: {
    type: Boolean, default: false,
  },
  label: {
    type: String, default: '',
  },
  width: {
    type: [Number, String], default: null,
  },
  options: {
    type: [Array, Object], default: () => [],
  },
})

const selectedValue = ref('')

const rulesAsString = useFilterVeeValidateRules(props.rules)

const colSpan = computed(() => {
  const width = parseInt(props.width) || props.formField?.width || 100

  switch (width) {
    case 25:
      return 'lg:col-span-3 col-span-12'
    case 33:
      return 'lg:col-span-4 col-span-12'
    case 50:
      return 'lg:col-span-6 col-span-12'
    case 66:
      return 'lg:col-span-8 col-span-12'
    default:
      return 'lg:col-span-12 col-span-12'
  }
})

const computedOptions = computed(() => {
  if (props.formField?.config?.options) {
    if (Array.isArray(props.formField.config.options)) {
      return props.formField.config.options.flatMap(option =>
        option.value,
      )
    }

    if (typeof props.formField.config.options === 'object') {
      return Object.values(props.formField.config.options)
    }
  }

  if (props.options?.length > 0) return props.options

  return []
})
</script>
